import { useResizeDetector } from 'react-resize-detector'
import cx from 'classnames'

import {
  SanityPrintAreaType,
  SanityPrintArea,
} from '@data/sanity/queries/types/print'
import {
  SanityPrintColor,
  SanityShopPrint,
} from '@data/sanity/queries/types/shop'

import Photo from '@components/photo'

interface PrintAreaProps {
  area: SanityPrintArea
  freetext?: string
  freetextColor: SanityPrintColor
  logo?: SanityShopPrint | null
  image?: SanityShopPrint | null
}

const PrintArea = ({
  area,
  freetext,
  freetextColor,
  logo,
  image,
}: PrintAreaProps) => {
  const { width, ref } = useResizeDetector()

  return (
    <div
      ref={ref}
      className={cx('absolute', {
        'z-10': area.type === SanityPrintAreaType.IMAGE,
        'z-20': area.type === SanityPrintAreaType.LOGO,
        'z-30': area.type === SanityPrintAreaType.TEXT,
      })}
      style={{
        width: `${area.width}%`,
        height: `${area.height}%`,
        left: `${area.x - area.width / 2}%`,
        top: `${area.y - area.height / 2}%`,
      }}
    >
      {area.type === SanityPrintAreaType.TEXT && (
        <p
          style={{ fontSize: width ? width / 10 : 8 }}
          className={cx(
            'text-center font-freetext font-bold whitespace-nowrap',
            {
              'text-black': freetextColor === 'dark',
              'text-white': freetextColor === 'light',
            },
          )}
        >
          {freetext}
        </p>
      )}

      {area.type === SanityPrintAreaType.LOGO && logo?.printImage && (
        <Photo image={logo.printImage} />
      )}

      {area.type === SanityPrintAreaType.IMAGE && image?.printImage && (
        <Photo image={image.printImage} />
      )}
    </div>
  )
}

export default PrintArea
